export const GET_SUBCRIPTIONSTATUS_REQUEST = "GET_SUBCRIPTIONSTATUS_REQUEST";
export const getSubcriptionStatusRequest = (payload) => ({
  type: GET_SUBCRIPTIONSTATUS_REQUEST,
  ...payload,
});



// WEBPACK FOOTER //
// ./src/pages/quiz/actions.js